/**
 * Shared error codes for use across frontend and backend.
 * Frontend uses these codes to look up translations.
 * Backend uses these codes when throwing errors.
 */
export const ErrorCode = {
  PRODUCT_NAME_EXISTS: 'PRODUCT_NAME_EXISTS',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  DISCOUNT_CODE_EXISTS: 'DISCOUNT_CODE_EXISTS',
  DISCOUNT_NOT_FOUND: 'DISCOUNT_NOT_FOUND',
  DISCOUNT_INVALID: 'DISCOUNT_INVALID',
  DISCOUNT_EXPIRED: 'DISCOUNT_EXPIRED',
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
  ORDER_ALREADY_FULFILLED: 'ORDER_ALREADY_FULFILLED',
  AUTH_UNAUTHORIZED: 'UNAUTHORIZED',
  AUTH_FORBIDDEN: 'FORBIDDEN',
  OAUTH_ACCOUNT_EMAIL_MISMATCH: "email_doesn't_match",
  OAUTH_ACCOUNT_NOT_LINKED: 'account_not_linked',
  OAUTH_ACCOUNT_ALREADY_LINKED: 'account_already_linked_to_different_user',
  OAUTH_ACCESS_DENIED: 'access_denied',
  OAUTH_INVALID_CODE: 'invalid_code',
  OAUTH_LINK_FAILED: 'oauth_link_failed',
  OAUTH_UNABLE_TO_LINK_ACCOUNT: 'unable_to_link_account',
  MODERATION_FLAGGED: 'MODERATION_FLAGGED',
  USER_NAME_INVALID: 'USER_NAME_INVALID',
  USERNAME_TAKEN: 'USERNAME_TAKEN',
  USERNAME_RESERVED: 'USERNAME_RESERVED',
  USERNAME_INVALID_FORMAT: 'USERNAME_INVALID_FORMAT',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'NOT_FOUND',
} as const

export type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode]
